function setCartDrawerUpsellOpen(block, isOpen) {
  block.classList.toggle('is-open', isOpen);
  const toggle = block.querySelector('[data-cart-drawer-upsell-toggle]');
  const panel = block.querySelector('.cart-drawer-upsell__panel');
  if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  if (panel) panel.hidden = !isOpen;
}

function initCartDrawerUpsell(root = document, { resetClosed = false } = {}) {
  root.querySelectorAll('[data-cart-drawer-upsell]').forEach((block) => {
    const isOpen = resetClosed ? false : block.classList.contains('is-open');
    setCartDrawerUpsellOpen(block, isOpen);
  });
}

function bindCartDrawerUpsellToggle() {
  if (window.__cartDrawerUpsellToggleBound) return;
  window.__cartDrawerUpsellToggleBound = true;

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('[data-cart-drawer-upsell-toggle]');
      if (!toggle) return;

      const block = toggle.closest('[data-cart-drawer-upsell]');
      if (!block || !block.closest('cart-drawer')) return;

      event.preventDefault();
      const isOpen = !block.classList.contains('is-open');
      setCartDrawerUpsellOpen(block, isOpen);
    },
    true
  );
}

bindCartDrawerUpsellToggle();
window.initCartDrawerUpsell = initCartDrawerUpsell;

document.addEventListener('DOMContentLoaded', initCartDrawerUpsell);
document.addEventListener('shopify:section:load', initCartDrawerUpsell);
